// 9fbef606107a605d69c0edbcd8029e5d
import { PRODUCT_DETAIL_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const SET_PRODUCT_DETAILS = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PLP_PRODUCTS`;
const SET_UPDATED_PRODUCT_DETAILS = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_UPDATED_PLP_PRODUCTS`;
const SET_UPDATED_MULTIPACK_VMP_NONVMP = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_UPDATED_MULTIPACK_VMP_PRODUCTS`;
const FETCH_PRODUCT_DETAILS = `${PRODUCT_DETAIL_ACTION_PATTERN}GET_PLP_PRODUCTS`;
const SET_ADD_TO_FAVORITE = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_ADD_TO_FAVORITE`;
const REMOVE_OUTFIT_ITEM_FROM_FAVORITE = `${PRODUCT_DETAIL_ACTION_PATTERN}REMOVE_OUTFIT_ITEM_FROM_FAVORITE`;
const SET_PDP_LOADING_STATE = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PDP_LOADING_STATE`;
const RESET_COUNT_UPDATED = `${PRODUCT_DETAIL_ACTION_PATTERN}RESET_COUNT_UPDATED`;
const SET_PRODUCT_DETAILS_DYNAMIC_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PRODUCT_DETAILS_DYNAMIC_DATA`;
const SET_UPDATED_PRODUCT_DETAILS_DYNAMIC_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_UPDATED_PRODUCT_DETAILS_DYNAMIC_DATA`;
const SET_PAGE_URL = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PAGE_URL`;
const SET_PDP_DISPLAY_PRICE = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PDP_DISPLAY_PRICE`;
const SET_MULTIPRODUCT_DETAILS = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_MULTIPRODUCT_DETAILS`;
const MULTIPACK_SELECTION = `${PRODUCT_DETAIL_ACTION_PATTERN}MULTIPACK_SELECTION`;
const SINGLE_TAB_STORE = `${PRODUCT_DETAIL_ACTION_PATTERN}SINGLE_TAB_STORE`;
const SET_DISABLE_SELECTED_TAB = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_DISABLE_SELECTED_TAB`;
const LOAD_SOCIAL_PROOF_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}LOAD_RECOMMENDATIONS_DATA`;
const CLEAR_SOCIAL_PROOF_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}CLEAR_SOCIAL_PROOF_DATA`;
const SET_PDP_CALLED_VIA_RECOMMENDATION = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PDP_CALLED_VIA_RECOMMENDATION`;
const SELECTED_SIZE_STATUS = `${PRODUCT_DETAIL_ACTION_PATTERN}SELECTED_SIZE_STATUS`;
const GET_REVIEW_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}GET_REVIEW_DATA`;
const SET_REVIEW_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_REVIEW_DATA`;
const UPDATE_DELIVERY_METHOD_INDEX = `${PRODUCT_DETAIL_ACTION_PATTERN}UPDATE_DELIVERY_METHOD_INDEX`;
const IS_SIDEBAR_MOUNTED = `${PRODUCT_DETAIL_ACTION_PATTERN}IS_SIDEBAR_MOUNTED`;
const SET_TAB_SECTION_NAME = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_TAB_SECTION_NAME`;
const SET_PLP_PRODUCT_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_PLP_PRODUCT_DATA`;
const SET_SLP_PRODUCT_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_SLP_PRODUCT_DATA`;
const SET_CART_PRODUCT_DATA = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_CART_PRODUCT_DATA`;
const PDP_TABS = [
  { key: 'Product Description', value: 'features' },
  { key: 'Reviews', value: 'reviews' },
  { key: 'Size Chart', value: 'sizeChart' },
  { key: 'Shipping & Returns', value: 'shipping' },
];
const PDP_TABS_WITH_QNA = [...PDP_TABS, { key: 'Questions & Answers', value: 'qna' }];
const FETCH_SIZECHART_MODULEX_CONTENT = `${PRODUCT_DETAIL_ACTION_PATTERN}FETCH_SIZECHART_MODULEX_CONTENT`;
const SET_RETURN_SIZECHART_MODULEX_CONTENT = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_RETURN_SIZECHART_MODULEX_CONTENT`;
const FETCH_ADDITIONAL_PROMO_MODULEX_CONTENT = `${PRODUCT_DETAIL_ACTION_PATTERN}FETCH_ADDITIONAL_PROMO_MODULEX_CONTENT`;
const FETCH_SHIPPING_AND_RETURNS_MODULEX_CONTENT = `${PRODUCT_DETAIL_ACTION_PATTERN}FETCH_SHIPPING_AND_RETURNS_MODULEX_CONTENT`;
const SET_SHIPPING_AND_RETURNS_MODULEX_CONTENT = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_SHIPPING_AND_RETURNS_MODULEX_CONTENT`;
const SET_ADDITIONAL_PROMO_MODULEX_CONTENT = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_ADDITIONAL_PROMO_MODULEX_CONTENT`;
const SET_SYTE_SCRIPT_LOADED = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_SYTE_SCRIPT_LOADED`;
const SET_ALTERNATE_STYLES = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_ALTERNATE_STYLES`;
const FETCH_DYNAMIC_CONTENT_PROMO = `${PRODUCT_DETAIL_ACTION_PATTERN}FETCH_DYNAMIC_CONTENT_PROMO`;
const SET_INDEX = `${PRODUCT_DETAIL_ACTION_PATTERN}SET_INDEX`;
const IS_DEPT_CLICKED = `${PRODUCT_DETAIL_ACTION_PATTERN}IS_DEPT_CLICKED`;
const IS_STICKY_ATB_LOADED = `${PRODUCT_DETAIL_ACTION_PATTERN}IS_STICKY_ATB_LOADED`;

const PRODUCTDETAIL_CONSTANTS = {
  SET_PRODUCT_DETAILS,
  SET_UPDATED_PRODUCT_DETAILS,
  SET_UPDATED_MULTIPACK_VMP_NONVMP,
  FETCH_PRODUCT_DETAILS,
  SET_ADD_TO_FAVORITE,
  REMOVE_OUTFIT_ITEM_FROM_FAVORITE,
  PROMO_TOP: 'top',
  PROMO_MIDDLE: 'middle',
  PROMO_BOTTOM: 'bottom',
  PROMO_BELOWRECS: 'bottomAplus',
  PROMO_PDP_DYNAMIC: 'pdpPromo',
  SET_PDP_LOADING_STATE,
  RESET_COUNT_UPDATED,
  SET_PRODUCT_DETAILS_DYNAMIC_DATA,
  SET_UPDATED_PRODUCT_DETAILS_DYNAMIC_DATA,
  SET_PAGE_URL,
  SET_PDP_DISPLAY_PRICE,
  FIRST_BREAD_CRUMB: 'Home',
  SET_MULTIPRODUCT_DETAILS,
  MULTIPACK_SELECTION,
  SINGLE_TAB_STORE,
  SET_DISABLE_SELECTED_TAB,
  LOAD_SOCIAL_PROOF_DATA,
  CLEAR_SOCIAL_PROOF_DATA,
  SET_PDP_CALLED_VIA_RECOMMENDATION,
  SELECTED_SIZE_STATUS,
  GET_REVIEW_DATA,
  SET_REVIEW_DATA,
  UPDATE_DELIVERY_METHOD_INDEX,
  IS_SIDEBAR_MOUNTED,
  SET_TAB_SECTION_NAME,
  PDP_TABS,
  PDP_TABS_WITH_QNA,
  SET_PLP_PRODUCT_DATA,
  SET_SLP_PRODUCT_DATA,
  FETCH_SIZECHART_MODULEX_CONTENT,
  SET_RETURN_SIZECHART_MODULEX_CONTENT,
  SET_SYTE_SCRIPT_LOADED,
  SET_ALTERNATE_STYLES,
  FETCH_DYNAMIC_CONTENT_PROMO,
  FETCH_ADDITIONAL_PROMO_MODULEX_CONTENT,
  SET_ADDITIONAL_PROMO_MODULEX_CONTENT,
  SET_INDEX,
  IS_DEPT_CLICKED,
  IS_STICKY_ATB_LOADED,
  SET_CART_PRODUCT_DATA,
  FETCH_SHIPPING_AND_RETURNS_MODULEX_CONTENT,
  SET_SHIPPING_AND_RETURNS_MODULEX_CONTENT,
};

export default PRODUCTDETAIL_CONSTANTS;
